import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { link } from '../../redux/actions/navigation'

/**
 * Component for creating a link with only text
 */
class TextLink extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    linkAction: PropTypes.func.isRequired,
    linkName: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    target: PropTypes.string,
    classNames: PropTypes.string
  };
  static defaultProps = {
    target: '',
    classNames: ''
  };
  constructor(props) {
    super(props);
    this.linkHandler = this.linkHandler.bind(this);
  }
  linkHandler() {
    const { linkAction, linkName, url } = this.props
    linkAction(linkName, url);
  }
  render() {
    const { url, text, target, classNames } = this.props;
    return (
      <a onClick={this.linkHandler} href={url} target={target} className={classNames}>
        {text}
      </a>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  linkAction: bindActionCreators(link, dispatch),
});

export default connect(() => ({}), mapDispatchToProps)(TextLink);




/** WEBPACK FOOTER **
 ** ./src/components/TextLink/index.js
 **/